/* eslint-disable */
import Vue from "vue"
import VueRouter from "vue-router"
import Header from "@/views/Header.vue"

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "Header",
    component: Header, 
    redirect: '/Index',
    children:[
      {
        path: '/Index',
        name: 'Index',
        component: () => import(/* webpackChunkName: "Index" */'@/views/Index.vue')
      },
      {
        path: '/ApiSolution',
        name: 'ApiSolution',
        component: () => import(/* webpackChunkName: "ApiSolution" */'@/views/ApiSolution.vue')
      },
      {
        path: '/EnterpriseSolution',
        name: 'EnterpriseSolution',
        component: () => import(/* webpackChunkName: "EnterpriseSolution" */'@/views/EnterpriseSolution.vue')
      }
    ],
  },
  {
    path: '/LegalNotice',
    name: 'LegalNotice',
    component: () => import(/* webpackChunkName: "LegalNotice" */'@/views/LegalNotice.vue')
  }
];
// const originalPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }
/**eslint-desable */
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
export default router;
